<template>
  <q-select
    v-if="isVisible"
    color="secondary"
    class="games-filter__input"
    outlined
    multiple
    v-model="userTypes"
    :options="userTypeList"
    option-value="id"
    option-label="Name"
    map-options
    emit-value
    label="User Type"
    clearable
    @input="handleUserTypeChange"
  />
</template>

<script>
export default {
  name: "UserTypeInput",
  props: {
    userTypeList: Array,
    currentUserTypes: Array,
    isVisible: Boolean,
  },
  data() {
    return {
      userTypes: [],
    };
  },
  methods: {
    handleUserTypeChange(event) {
      this.$emit("userTypeChange", event);
    },
  },
  watch: {
    currentUserTypes() {
      this.userTypes = this.currentUserTypes;
    },
  },
};
</script>
